import { useAlert } from 'shared/components/alerts';
import { useSiteDetection } from 'shared/hooks';
import { useBlockUser } from './use-block-user';
import { useUnblockUser } from './use-unblock-user';
import { PaymentUsersFilters } from './use-payment-users.types';

export const useGetPaymentUsersActionHandlers = (appliedFilters: PaymentUsersFilters) => {
  const blockUserMutation = useBlockUser(appliedFilters);
  const unblockUserMutation = useUnblockUser(appliedFilters);
  const { alertSuccess, alertError } = useAlert();
  const { site } = useSiteDetection();

  const handleBlockUser = (flexWorkerId: string) => {
    blockUserMutation.mutate(
      { site, flexWorkerId },
      {
        onSuccess: () => alertSuccess('Betaling succesvol geblokkeerd'),
        onError: alertError,
      }
    );
  };

  const handleUnblockUser = (flexWorkerId: string) => {
    unblockUserMutation.mutate(
      { site, flexWorkerId },
      {
        onSuccess: () => alertSuccess('Betaling succesvol gedeblokkeerd'),
        onError: alertError,
      }
    );
  };

  return {
    handleBlockUser,
    handleUnblockUser,
  };
};
